import { render, staticRenderFns } from "./StateUpdating.vue?vue&type=template&id=55de9342&scoped=true&"
import script from "./StateUpdating.vue?vue&type=script&lang=js&"
export * from "./StateUpdating.vue?vue&type=script&lang=js&"
import style0 from "./StateUpdating.vue?vue&type=style&index=0&id=55de9342&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55de9342",
  null
  
)

export default component.exports